const MOCK_TEST_EMAIL = 'test@bound.ly';
const MOCK_SESSION_STORAGE_KEY = 'isMockTestSession';
const MOCK_ONBOARDING_STORAGE_KEY = 'mockTestOnboarding';

function isMockTestEmail(email) {
    return String(email).trim().toLowerCase() === MOCK_TEST_EMAIL;
}

function isMockTestSession() {
    return localStorage.getItem(MOCK_SESSION_STORAGE_KEY) === 'true';
}

function startMockTestSession() {
    localStorage.setItem(MOCK_SESSION_STORAGE_KEY, 'true');
}

function endMockTestSession() {
    localStorage.removeItem(MOCK_SESSION_STORAGE_KEY);
    localStorage.removeItem(MOCK_ONBOARDING_STORAGE_KEY);
}

function getMockOnboarding() {
    return JSON.parse(localStorage.getItem(MOCK_ONBOARDING_STORAGE_KEY)) || {};
}

function saveMockOnboardingStep({ onboardingType, isFinished }) {
    const onboarding = {
        ...getMockOnboarding(),
        [onboardingType]: { isFinished }
    };

    localStorage.setItem(MOCK_ONBOARDING_STORAGE_KEY, JSON.stringify(onboarding));
}

function getMockUserProfile() {
    return {
        id: 'mock-test-user',
        email: MOCK_TEST_EMAIL,
        firstName: 'Test',
        onboarding: getMockOnboarding(),
        subscriptionFeatures: ['memoryKeeper']
    };
}

export {
    MOCK_TEST_EMAIL,
    isMockTestEmail,
    isMockTestSession,
    startMockTestSession,
    endMockTestSession,
    saveMockOnboardingStep,
    getMockUserProfile
};
